import MetaMaskSDK, { SDKProvider } from '@metamask/sdk';
import { ethers } from 'ethers';
import { getABIFile } from './getABIFile.utils';
import { getCurrencyAddress } from './getCurrencyAddress.utils';
import { truncateDecimal } from './truncateDecimal.utils';

export async function getMetaMaskNonNativeCurrencyBalance(
  provider: SDKProvider | ethers.providers.Web3Provider,
  currencyContractAddress: string,
  currency: string
): Promise<number> {
  try {
    // If provider is SDKProvider, wrap it for ethers compatibility
    const ethersProvider: ethers.providers.Web3Provider = new ethers.providers.Web3Provider(provider as any);
    const signer = ethersProvider.getSigner();
    const signerAddress = await signer.getAddress();
    const abiFile = getABIFile(currency);
    const contract = new ethers.Contract(currencyContractAddress, abiFile, signer);
    const balanceOf = await contract.balanceOf(signerAddress);
    const balance = parseFloat(ethers.utils.formatUnits(balanceOf, 18));

    return balance;
  } catch {
    return 0;
  }
}

const getMetaMaskBalance = async (metaMaskSdk: MetaMaskSDK | null, address: string | undefined, chainId: number) => {
  if (!metaMaskSdk)
    return {
      native: 0,
      nonNative: 0
    };

  const provider = metaMaskSdk.activeProvider || metaMaskSdk.getProvider();

  if (!provider)
    return {
      native: 0,
      nonNative: 0
    };

  const currency = chainId === 80001 || chainId === 137 ? 'WMATIC' : 'WETH';
  const contractAddress = getCurrencyAddress(chainId);

  try {
    const balanceData = (await provider.request({
      method: 'eth_getBalance',
      params: [address, 'latest']
    })) as string;

    const nonNativeBalance = await getMetaMaskNonNativeCurrencyBalance(provider, contractAddress, currency);
    const nativeBalance = ethers.utils.formatEther(String(balanceData));

    return {
      native: +truncateDecimal(nativeBalance),
      nonNative: +truncateDecimal(nonNativeBalance)
    };
  } catch {
    return {
      native: 0,
      nonNative: 0
    };
  }
};

export default getMetaMaskBalance;
